import { get } from 'lodash'

import { CONFIGURATION_KEYS, LEVELS, ORGANIZATION_HIERARCHY, PARTICIPANTS_BULK, ROLES } from 'constants/enums'
import modals from '../../modals'

export const tabsList = (modal, visible) => [
  {
    id: 1,
    label: 'My Participants',
    intlKey: 'tabs.my_participants',
    path: '/my-participants',
    authorized: true
  },
  {
    id: 2,
    label: 'All Participants',
    intlKey: 'tabs.all_participants',
    path: '/all-participants',
    authorized: false
  },
  {
    id: 3,
    label: 'Invite Participants',
    intlKey: 'button.invite_participants',
    func: () => { modal(modals.INVITE_PARTICIPANTS_MODAL)},
    authorized: true,
    visible: visible,
    type: 'action'
  }
]

export const tabsDetail = [
  {
    id: 1,
    label: 'Detail',
    intlKey: 'tabs.detail',
    maxLevel: 3,
    path: '/detail',
    roles: [ROLES.ALL.u]
  },
  {
    id: 3,
    label: 'Bronze Level',
    intlKey: 'tabs.bronze_level',
    maxLevel: 3,
    path: '/bronze-level',
    roles: [ROLES.ALL.u],
    className: 'tab-bronze',
    onlyFor: LEVELS.BRONZE.value,
    visibility: 'hidden'
  },
  {
    id: 4,
    label: 'Silver Level',
    intlKey: 'tabs.silver_level',
    maxLevel: 3,
    path: '/silver-level',
    roles: [ROLES.ALL.u],
    className: 'tab-silver',
    onlyFor: LEVELS.SILVER.value,
    visibility: 'hidden'
  },
  {
    id: 5,
    label: 'Gold level',
    intlKey: 'tabs.gold_level',
    maxLevel: 3,
    path: '/gold-level',
    roles: [ROLES.ALL.u],
    className: 'tab-gold',
    onlyFor: LEVELS.GOLD.value,
    visibility: 'hidden'
  },
  {
    id: 6,
    label: 'History log',
    intlKey: 'tabs.history_log',
    maxLevel: 3,
    path: '/history',
    roles: [ROLES.ALL.u]
  }

  // {
  //   id: 3,
  //   label: 'Award',
  //   intlKey: 'tabs.award',
  //   path: '/award',
  //   roles: [ROLES.NAO_STAFF.u]
  // }
]

export const tableHeaders = ({ organizationHierarchyId, showLastActivity, isLabelsEnabled, isAwardLabelsEnabled, isAssessorParticipants = false }) => [
  {
    id: 0,
    label: '',
    intlKey: '',
    sortableId: '',
    selector: true
  },
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name',
    sortableId: 'firstName'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name',
    sortableId: 'lastName'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email',
    sortableId: 'email'
  },
  {
    id: 5,
    label: 'Levels',
    intlKey: 'table.levels',
    sortable: false
  },
  {
    id: 6,
    label: 'Last log added',
    intlKey: 'table.last_log_added',
    sortable: false,
    hide: !showLastActivity
  },
  {
    id: 7,
    label: 'Assessed Activities',
    intlKey: 'table.assessed_activities',
    hide: !isAssessorParticipants
  },
  {
    id: 8,
    label: 'Labels',
    intlKey: 'table.labels',
    sortableId: 'labels.label.name',
    hide: !isLabelsEnabled
  },
  {
    id: 9,
    label: 'Award Labels',
    intlKey: 'table.award_labels',
    sortableId: 'labels.label.name',
    hide: !isAwardLabelsEnabled
  },
  {
    id: 10,
    label: 'Award Leader',
    intlKey: 'table.award_leader',
    sortableId: 'awards.awardLeader.person.lastName'
  },
  {
    id: 11,
    label: 'Award Unit',
    intlKey: 'table.award_unit',
    displayForRoles: [
      ROLES.NAO_STAFF.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_REGION.u,
      ROLES.IF_STAFF_USER.u,
      ROLES.IF_STAFF_VIEWER.u
    ]
  },
  {
    id: 12,
    label: 'NAO',
    intlKey:
      organizationHierarchyId === ORGANIZATION_HIERARCHY.IC.id
        ? 'table.ic'
        : 'table.country',
    displayForRoles: [
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_REGION.u,
      ROLES.IF_STAFF_USER.u,
      ROLES.IF_STAFF_VIEWER.u
    ]
  },
  {
    id: 13,
    label: 'Status',
    intlKey: 'table.status',
    sortableId: 'personState.value'
  }
]

export const bulkPersonOptions = (intl, permissions, configuration, userType) => {
  const options = [
    {
      value: PARTICIPANTS_BULK.resendParentalConsent.id,
      label: intl.formatMessage({ id: 'button.resend_parental_consent', defaultMessage: 'Resend parental consent' })
    },
    {
      value: PARTICIPANTS_BULK.inactive.id,
      label: intl.formatMessage({ id: 'states.inactive', defaultMessage: 'Archive' })
    },
    {
      value: PARTICIPANTS_BULK.transferParticipants.id,
      label: intl.formatMessage({ id: 'label.transfer_participants', defaultMessage: 'Transfer participants (change AC, AL)' })
    },
    {
      value: PARTICIPANTS_BULK.resendConfirmationEmail.id,
      label: intl.formatMessage({ id: 'label.resend_confirmation_email', defaultMessage: 'Resend confirmation email' })
    },
    {
      value: PARTICIPANTS_BULK.changeParentalConsent.id,
      label: intl.formatMessage({ id: 'label.change_parental_consent', defaultMessage: 'Change parental consent' })
    }
  ]

  if ((get(permissions, 'isSuperior') && userType !== ROLES.LEADER.u) || (userType === ROLES.LEADER.u && get(configuration, `values[${CONFIGURATION_KEYS.isChangeCompleteToCeremonyForAwardLeadersAllowed.id}].booleanValue`))) {
    options.push({
      value: PARTICIPANTS_BULK.toCeremony.id,
      label: intl.formatMessage({ id: 'states.completed', defaultMessage: 'Completed' })
        + ' => '
        + intl.formatMessage({ id: 'states.ceremony', defaultMessage: 'Ceremony' })
    })
  }

  if (get(permissions, 'isSuperior') && userType !== ROLES.LEADER.u) {
    options.push({
      value: PARTICIPANTS_BULK.offlineToComplete.id,
      label: intl.formatMessage({ id: 'label.offline_to_complete', defaultMessage: 'Offline to Completed' })
    })
  }

  if (userType !== ROLES.IF_STAFF_SUPER.u && get(configuration, `values[${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)) {
    options.push({
      value: PARTICIPANTS_BULK.assignLabels.id,
      label: intl.formatMessage({ id: 'label.assign_labels', defaultMessage: 'Assign Labels' })
    })
  }

  if (userType !== ROLES.IF_STAFF_SUPER.u && get(configuration, `values[${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)) {
    options.push({
      value: PARTICIPANTS_BULK.unassignLabels.id,
      label: intl.formatMessage({ id: 'label.unassign_labels', defaultMessage: 'Unassign Labels' })
    })
  }

  if (userType !== ROLES.IF_STAFF_SUPER.u && get(configuration, `values[${CONFIGURATION_KEYS.enableAwardLabels.id}].booleanValue`)) {
    options.push({
      value: PARTICIPANTS_BULK.assignAwardLabels.id,
      label: intl.formatMessage({ id: 'label.assign_award_labels', defaultMessage: 'Assign Award Labels' })
    })
  }

  if (userType !== ROLES.IF_STAFF_SUPER.u && get(configuration, `values[${CONFIGURATION_KEYS.enableAwardLabels.id}].booleanValue`)) {
    options.push({
      value: PARTICIPANTS_BULK.unassignAwardLabels.id,
      label: intl.formatMessage({ id: 'label.unassign_award_labels', defaultMessage: 'Unassign Award Labels' })
    })
  }

  if (get(configuration, `values[${CONFIGURATION_KEYS.isMessagingEnabled.id}].booleanValue`)) {
    options.push({
      value: PARTICIPANTS_BULK.sendMessage.id,
      label: intl.formatMessage({ id: 'label.send_message', defaultMessage: 'Send message' })
    })
  }

  options.push({
    value: PARTICIPANTS_BULK.nextLevelInvitation.id,
    label: intl.formatMessage({ id: 'contact.next_level_invitation', defaultMessage: 'Next level invitation' })
  })

  options.push({
    value: PARTICIPANTS_BULK.collectEmails.id,
    label: intl.formatMessage({ id: 'contact.collect_emails', defaultMessage: 'Collect email addresses for emailing' })
  })

  return options
}

export const bulkForm = 'participants-bulkChange'
